import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { authReducer } from "../../components/auth/slice";
import { localApi } from "../../services/local/api";
import { mainApi } from "../../services/main/api";
import { timeReducer } from "../../features/time/slice";
import { editDocumentReducer } from "../../components/edit-document-modal/slice";
import { breadcrumbsReducer } from "../../features/breadcrumbs/slice";
import { sheetsReducer } from "../../features/sheets/slice";
import { pageHeaderReducer } from "../../features/page-header/slice";
import { filterSheetsReducer } from "../../features/filter-sheets/slice";
import { tableReducer } from "../../components/table/slice";
import { notificationsReducer } from "../../features/notifications/slice";

export const store = configureStore({
    reducer: {
        auth: authReducer,
        breadcrumbs: breadcrumbsReducer,
        pageHeader: pageHeaderReducer,
        sheets: sheetsReducer,
        filterSheets: filterSheetsReducer,
        table: tableReducer,
        editDocuments: editDocumentReducer,
        time: timeReducer,
        notifications: notificationsReducer,
        [localApi.reducerPath]: localApi.reducer,
        [mainApi.reducerPath]: mainApi.reducer,
    },
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware({
            // Note: One of the core usage principles for Redux is that you should not put
            // non-serializable values in state or actions.
            // See: https://redux-toolkit.js.org/usage/usage-guide#working-with-non-serializable-data
            // We turn it off to allow the infoReducer actions to accept non-serializable state value
            // to update the AppLayout tools' inner content with a ReactNode.
            serializableCheck: false,
        })
            .concat(localApi.middleware)
            .concat(mainApi.middleware),
});

setupListeners(store.dispatch);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;

// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
